import { map } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { RouterAction } from '@cbridge-packages/routing';
import { generateMarkupRoute } from '@cbridge-packages/routing-client-admin';
import { MarkupAction } from '@cbridge-packages/markup';

export const toggleViewMarkupSidebarEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(MarkupAction.update.done),
  map(({ params }) => RouterAction.replace([generateMarkupRoute(params.profileId, params.markup.symbolId)])),
);
